import EcoBlockAnchor from './EcoBlockAnchor.vue'

export default EcoBlockAnchor
